module.exports = __webpack_public_path__ + "img/product-placeholder-60.6ec33d2.png";